import { 
  Button, 
  Flex,
} from "@components/index";
import { useSafeNavigate } from "@routes/hooks/useSafeNavigate";

const Header: React.FC = () => {
  const navigate = useSafeNavigate();
  
  const goToNewProcesses = () => {
    void navigate("/processes/new");
  };

  return (
    <Flex justifyContent="end" className="p-10">
      <Button label="Novo" icon="add" size="lg" onClick={goToNewProcesses} />
    </Flex>
  );
}

export default Header;